import { VExternalAspectRemote } from "../api/external-aspect";
import { VHouseExternalAspect, VRetailBuildingExternalAspect, VWarehouseExternalAspect } from "../common/external-aspect";

export function mapVHouseExternalAspectRemoteToDomain(remote: VExternalAspectRemote): VHouseExternalAspect {
  return {
    chimneyStack: remote.chimney_stack_name,
    chimneyStackComment: remote.chimney_stack_comment,
    roofCovering: remote.roof_covering_name,
    roofCoveringComment: remote.roof_covering_comment,
    rainwaterPipe: remote.rainwater_pipe_name,
    rainwaterPipeComment: remote.rainwater_pipe_comment,
    mainWall: remote.main_wall_name,
    mainWallComment: remote.main_wall_comment,
    window: remote.window_type_name,
    windowComment: remote.window_type_comment,
    outsideDoor: remote.outside_door_name,
    outsideDoorComment: remote.outside_door_comment,
    conservatory: remote.conservatory_name,
    conservatoryComment: remote.conservatory_comment,
    otherJoinery: remote.other_joinery_name,
    otherJoineryComment: remote.other_joinery_comment,
    others: remote.has_other ? remote.other_aspects : null
  }
}

export function mapVRetailBuildingExternalAspectRemoteToDomain(remote: VExternalAspectRemote): VRetailBuildingExternalAspect {
  return {
    roofCovering: remote.roof_covering_name,
    roofCoveringComment: remote.roof_covering_comment,
    rainwaterPipe: remote.rainwater_pipe_name,
    rainwaterPipeComment: remote.rainwater_pipe_comment,
    mainWall: remote.main_wall_name,
    mainWallComment: remote.main_wall_comment,
    window: remote.window_type_name,
    windowComment: remote.window_type_comment,
    outsideDoor: remote.outside_door_name,
    outsideDoorComment: remote.outside_door_comment,
    loadingDock: remote.loading_dock ? `Yes. ${remote.loading_dock_comment ?? ''}` : 'No',
    others: remote.has_other ? remote.other_aspects : null
  }
}

export function mapVWarehouseExternalAspectRemoteToDomain(remote: VExternalAspectRemote): VWarehouseExternalAspect {
  return {
    roofCovering: remote.roof_covering_name,
    roofCoveringComment: remote.roof_covering_comment,
    rainwaterPipe: remote.rainwater_pipe_name,
    rainwaterPipeComment: remote.rainwater_pipe_comment,
    mainWall: remote.main_wall_name,
    mainWallComment: remote.main_wall_comment,
    window: remote.window_type_name,
    windowComment: remote.window_type_comment,
    outsideDoor: remote.outside_door_name,
    outsideDoorComment: remote.outside_door_comment,
    loadingDock: remote.loading_dock ? `Yes. ${remote.loading_dock_comment ?? ''}` : 'No',
    others: remote.has_other ? remote.other_aspects : null
  }
}